module.exports = "//static.hsappstatic.net/settings-ui-app/static-1.16253/modules/marketing/modules/esp-sync/images/getresponse.png"